import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';

export type ReactHookFormSwitchProps<
    FormFields extends FieldValues,
    TContext extends object = object,
> = Omit<SwitchProps, 'name' | 'control'> & {
    control: Control<FormFields, TContext>;
    name: Path<FormFields>;
    label: React.ReactNode;
    readonly?: boolean;
};

export function ReactHookFormSwitch<
    FormFields extends FieldValues,
    TContext extends object = object,
>({
    name,
    control,
    label,
    readonly,
    onChange: externalChange,
    ...props
}: ReactHookFormSwitchProps<FormFields, TContext>) {
    return (
        <Controller<FormFields>
            name={name}
            control={control}
            render={({ field: { onChange, value = false } }) => (
                <FormControlLabel
                    control={
                        <Switch
                            checked={value}
                            onChange={(e, checked) => {
                                onChange(checked);
                                if (externalChange) {
                                    externalChange(e, checked);
                                }
                            }}
                            disabled={readonly}
                            {...props}
                        />
                    }
                    label={label}
                />
            )}
        />
    );
}
